/* ============================================================
   234LABS — product-reviews.js
   - "Show more reviews" reveal.
   - Write-a-review dialog: open/close (same pattern as the size-guide and
     newsletter-popup dialogs elsewhere in the theme).
   - Star-picker widget + folds the rating and product into the single
     contact[body] field before submit, so it all lands in one place in the
     merchant's inbox — no app, no backend, Shopify's own contact form mailer.
   ============================================================ */
if (!window.__234reviewsInit) {
  window.__234reviewsInit = true;

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-review-show-more]')) {
      document.querySelectorAll('[data-review-extra]').forEach((el) => el.removeAttribute('hidden'));
      e.target.closest('[data-review-show-more]').remove();
      return;
    }

    if (e.target.closest('[data-review-form-open]')) {
      document.querySelector('[data-review-form]')?.showModal();
      return;
    }

    const dlg = document.querySelector('[data-review-form]');
    if (dlg && (e.target.closest('[data-review-form-close]') || e.target === dlg)) {
      dlg.close();
      return;
    }

    const starBtn = e.target.closest('.star-picker__btn');
    if (starBtn) {
      const picker = starBtn.closest('[data-star-picker]');
      const value = Number(starBtn.dataset.starValue);
      picker.dataset.value = value;
      [...picker.children].forEach((btn, i) => btn.classList.toggle('is-active', i < value));
    }
  });

  document.addEventListener(
    'mouseover',
    (e) => {
      const starBtn = e.target.closest('.star-picker__btn');
      if (!starBtn) return;
      const picker = starBtn.closest('[data-star-picker]');
      const hoverValue = Number(starBtn.dataset.starValue);
      [...picker.children].forEach((btn, i) => btn.classList.toggle('is-hover', i < hoverValue));
    },
    { passive: true }
  );
  document.addEventListener(
    'mouseout',
    (e) => {
      const picker = e.target.closest('[data-star-picker]');
      if (!picker || picker.contains(e.relatedTarget)) return;
      picker.querySelectorAll('.is-hover').forEach((btn) => btn.classList.remove('is-hover'));
    },
    { passive: true }
  );

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.review-form');
    if (!form) return;

    const picker = form.querySelector('[data-star-picker]');
    const rating = Number(picker?.dataset.value || 0);
    if (!rating) {
      e.preventDefault();
      let note = form.querySelector('[data-star-note]');
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-star-note', '');
        note.className = 'label review-form__note';
        note.style.color = 'var(--v-red, crimson)';
        picker.after(note);
      }
      note.textContent = 'Pick a star rating first.';
      return;
    }

    const bodyEl = form.querySelector('[data-review-body]');
    const productEl = form.querySelector('[data-review-product]');
    if (bodyEl) {
      const stars = '★'.repeat(rating) + '☆'.repeat(5 - rating);
      const product = productEl ? productEl.value : '';
      bodyEl.value = `Rating: ${stars} (${rating}/5)\nProduct: ${product}\n\n${bodyEl.value}`;
    }
    // let the form submit normally — it's a real (non-AJAX) Shopify contact
    // form post, same pattern as the newsletter signup elsewhere.
  });
}
